import { Exclude, Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { PhotoDto } from '../../photo/dto/photo.dto';
import { JobPhasePhotoInterface } from '../interfaces/job-phase-photo.interface';

@Exclude()
export class JobPhasePhotoDto
  extends PhotoDto
  implements JobPhasePhotoInterface
{
  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;
}
